module.exports = __webpack_public_path__ + "static/banner-lottery-e1a518630b8f88dd2413af6a7c53a492.jpg";